import { CustomValueTagPill } from "PFApp/components/custom_value_tag_pill";
import { useCustomValueTags } from "PFApp/hooks/use_custom_value_tags";
import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { PureCustomValueCamelCased } from "PFCore/types";
import { useTranslation } from "react-i18next";

import css from "./tags_section.module.scss";

type TagsSectionProps = {
  customValue: PureCustomValueCamelCased;
};

export const TagsSection = ({ customValue }: TagsSectionProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "customValueSidepanel" });
  const { getCustomValueTags } = useCustomValueTags();

  const tags = getCustomValueTags(customValue.tagIds);

  return (
    <Stack gap="spacingMd">
      <Typography variant="h5">{t("tags")}</Typography>
      {tags.length > 0 ? (
        <Inline wrap="wrap">
          {tags.map((tag) => (
            <CustomValueTagPill key={tag.id} tag={tag} />
          ))}
        </Inline>
      ) : (
        <Stack alignItems="center" gap="spacingSm">
          <Icon name="missing" color="paletteBlue2" />
          <Typography variant="labelRegular" className={css.grayText}>
            {t("noTagsAdded")}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
